<template>
	<span>
		<div class="table-responsive">
			<table class="table table-hover">
				<thead>
					<tr>
						<th>{{ nameHeader }}</th>
						<th>{{ sizeHeader }}</th>
						<th>{{ removeHeader }}</th>
					</tr>
				</thead>
				<tbody :id="`drop_${inputId}`">
					<tr v-if="!files.length" class="dropField drop-active">
						<td colspan="7">
							<div class="text-center p-5">
								<h4 class="hidden-sm hidden-xs">
									<template v-if="multiple">
										{{ dropMultipleFiles }}
									</template>
									<template v-else>
										{{ dropSingleFile }}
									</template>
								</h4>
								<h4 class="hidden-md hidden-lg">
									<template v-if="multiple">
										{{ selectMultipleFiles }}
									</template>
									<template v-else>
										{{ selectSingleFile }}
									</template>
								</h4>
							</div>
						</td>
					</tr>
					<tr v-for="(file, fileIndex) in files" :key="fileIndex">
						<td>
							<div class="row">
								<div class="filename col-md-5">
									{{file.name}}
								</div>
								<div class="col-md-7">
									<div class="progress" v-if="file.active || !file.success || file.progress !== '0.00'">
										<div :class="{'progress-bar': true, 'progress-bar-striped': true, 'progress-bar-danger': (!file.active && !file.success), 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.success ? file.progress + '%' : '100%'}">
											<template v-if="file.success">{{file.progress}}%</template>
											<template v-if="!file.success">{{getErrorMessage(file.error)}}</template>
										</div>
									</div>
								</div>
							</div>
						</td>
						<td>{{Math.floor(file.size / 1024)}}kb</td>
						<td>
							<i class="fa fa-trash" @click="removeFile(fileIndex)"></i>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row">
			<div class="col-xs-12 col-md-6">
				<label for="files" v-id="dropzoneID.length && inputId.length">
					<file-upload class="btn btn-default dropdown-toggle"
											ref="upload"
											:accept="accept"
											:value="files"
											:multiple="multiple"
											:size="size"
											:active="false"
											:drop="`#drop_${inputId}`"
											:postAction="postAction"
											:headers="auth"
											@input="updateValue"
											:input-id="inputId">
						<i class="fa fas fa-paperclip" aria-hidden="true"></i> <template v-if="multiple">{{ attachFiles }}</template><template v-else>{{ attachFile }}</template>
					</file-upload>
				</label>
				<vue-friendly-iframe v-if="!!URL.API_ORIGIN_URL"
														 class="noBorder"
														 :class="{ 'thirdPartyFileUploader': resize, 'maxHeight55': !resize }"
														 :src="`${URL.API_ORIGIN_URL}?GOOGLE_API_CLIENT_ID=${URL.GOOGLE_API_CLIENT_ID}&GOOGLE_API_APP_ID=${URL.GOOGLE_API_APP_ID}&DROPBOX_API_CLIENT_ID=${URL.DROPBOX_API_CLIENT_ID}&ONEDRIVE_API_CLIENT_ID=${URL.ONEDRIVE_API_CLIENT_ID}&origin=${getOriginURL()}`"
														 ref="externalFileUploads"
														 :allowfullscreen="'true'"
														 style="width: 100%; border: none;">
				</vue-friendly-iframe>
			</div>
		</div>
	</span>
</template>

<script>
	import FileUpload from 'vue-upload-component';
	import VueFriendlyIframe from 'vue-friendly-iframe';
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import { library } from '@fortawesome/fontawesome-svg-core';
	import { faGoogleDrive, faDropbox } from '@fortawesome/free-brands-svg-icons';
	import { faCloud } from '@fortawesome/free-solid-svg-icons';

	library.add(faGoogleDrive);
	library.add(faDropbox);
	library.add(faCloud);

	export default {
		name: 'FileUploader',
		props: {
			files: {
				type: Array,
				default: function() {
					return []
				}
			},
			size: {
				type:  Number,
				default: 0
			},
			multiple: {
				type: Boolean,
				default: true,
			},
			postAction: {
				type: String,
				required: true
			},
			URL: {
				type: Object,
				required: true
			},
			auth: {
				type: Object
			},
			termData: {
				type: Object,
				default: function() {
					return {};
				}
			},
			accept: {
				type:String,
				default: function() {
					return "*"
				}
			},
			inputId:{
				type: String,
				default: function() {
					return "FileInputId"
				}
			},
			nameHeader: {
				type: String,
				default: "Name"
			},
			sizeHeader: {
				type: String,
				default: "Size"
			},
			removeHeader: {
				type: String,
				default: "Remove"
			},
			dropSingleFile: {
				type: String,
				default: "Drop a file here to upload"
			},
			dropMultipleFiles: {
				type: String,
				default: "Drop files here to upload"
			},
			selectSingleFile: {
				type: String,
				default: "Select a file to upload"
			},
			selectMultipleFiles: {
				type: String,
				default: "Select files to upload"
			},
			attachFile: {
				type: String,
				default: "Attach a file"
			},
			attachFiles: {
				type: String,
				default: "Attach files"
			}
		},
		data() {
			return {
				resize: false,
				counter: 0,
				dropzoneID:"",
			};
		},
		components: {
			FileUpload,
			FontAwesomeIcon,
			VueFriendlyIframe
		},
		methods: {
			getErrorMessage(error){
				if( error === 'size' ) {
					const sizeInKb = this.size / 1024;
					return `Error: File size to large must be less than ${sizeInKb}kb`;
				}

				return error;
			},
			dropFiles(e) {
				let droppedFiles = e.dataTransfer.files;
				let files = []

				if(!droppedFiles) {
					return;
				}

				([...droppedFiles]).forEach(f => {
					files.push({
						f
					});
				});

				this.$emit('droppedFiles', droppedFiles);
			},
			updateValue(files) {
				this.$emit('updateFiles', files);
				this.$refs.upload.active = true;
			},
			removeFile(index) {
				this.files.splice(index, 1);
			},
			getOriginURL() {
				return `${window.location.protocol}//${window.location.host}`;
			},
			listener(event) {
				const self = this;

				if(event.data === 'resizeIframe') {
					this.resize = true;
				} else if(event.data === 'pickerDone') {
					this.resize = false;
				}

				if(typeof event.data === 'object') {
					if(!event.data.source) {
						let files = event.data;

						try {
							if(files.toString().indexOf("!_") != -1)
								return;
						} catch (e) {}

						if (files.apiType) {
							// the iframe returned a file
							if (files.apiType == "onedrive") {
								!self.termData ?
									self.$emit('saveOneDriveFilesData', files.value[0]) :
									self.$emit('saveOneDriveFilesData', files.value[0], this.termData);
							}

							if(files.apiType == "dropbox") {
								!self.termData ?
									self.$emit('saveDropboxFilesData', files[0]) :
									self.$emit('saveDropboxFilesData', files[0], this.termData);
							}

							if(files.apiType === 'google') {
								!self.termData ?
									self.$emit('saveGoogleFilesData', files) :
									self.$emit('saveGoogleFilesData', files, this.termData);
							}
						}
					}
				}
			}
		},
		mounted() {
			/*
				This File Contains functions for communicating and utlilizing the google, dropbox, and OneDrive api pickers
			*/

			window.iframe = '';

			window.addEventListener ?
				addEventListener("message", this.listener, false) :
				attachEvent("onmessage", this.listener);
		}
	}
</script>

<style scoped>
.drop-active:hover {
  opacity: .6;
  background: #ccc;
}
</style>
